export const COMPARE_TYPES = { SELECTION: 'selection', GRADE: 'grade', NUMERIC: 'numeric' }

export const DISPLAY_MODES = {
  COUNT: 'count',
  PERCENTAGE: 'percentage',
  ROW_PERCENTAGE: 'row_percentage',
  AVERAGE_GRADE: 'average_grade',
  SATISFACTION: 'satisfaction'
}

export const COLUMN_HEADER_MAX_WIDTH = { maxWidth: '200px' }

export const DEBOUNCE_DELAY = 400

export const SAVE_PREFERENCES_DELAY = 1000

export const SELECTION_DISPLAY_OPTIONS = [
  { value: DISPLAY_MODES.COUNT, label: 'Valeurs' },
  { value: DISPLAY_MODES.PERCENTAGE, label: 'Pourcentages' },
  { value: DISPLAY_MODES.ROW_PERCENTAGE, label: 'Pourcentages en ligne' }
]

export const GRADE_DISPLAY_OPTIONS = [
  { value: DISPLAY_MODES.AVERAGE_GRADE, label: 'Note moyenne' },
  { value: DISPLAY_MODES.SATISFACTION, label: 'Taux de satisfaction' }
]

export const ALL_TYPE_OPTIONS = [
  { value: COMPARE_TYPES.SELECTION, label: 'Question choix' },
  { value: COMPARE_TYPES.GRADE, label: 'Question notation' },
  { value: COMPARE_TYPES.NUMERIC, label: 'Question numérique' }
]
